// components/customer-dashboard/customer-dashboard.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { AuthService } from '../../components/services/auth.service';
import { BookingService } from '../../components/services/booking.service'; 
import { User } from '../../objects/user';
import { Service } from '../../objects/service';
import { Booking } from '../../objects/booking';
import { Project } from 'src/app/objects/Project';
import { ProjectService } from 'src/app/Services/project.services';


@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.css']
})
export class CustomerDashboardComponent implements OnInit {
  currentUser: User | null = null;
  bookings: Booking[] = [];
  projects: Project[] = [];
  
  // Review modal properties
  showReviewModal: boolean = false;
  selectedBookingId: string | null = null;
  reviewRating: number = 0;
  reviewComment: string = '';

  constructor(
    private projectService: ProjectService,
    private authService: AuthService,
    private bookingService: BookingService,
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    if (this.currentUser) {
      this.loadBookings();
      this.loadProjects();
    }
  }

  loadBookings(): void {
    // Mock bookings data
    this.bookings = [
      {
        id: '1',
        customerId: this.currentUser!.id,
        providerId: 1,
        serviceId: 's1',
        serviceName: 'Weekly Lawn Care Service',
        providerName: 'Green Thumb Landscaping',
        scheduledDate: '2025-07-01',
        scheduledTime: '09:00',
        status: 'confirmed',
        price: 93.99,
        isRecurring: true,
        recurringFrequency: 'Weekly',
        address: '123 Main St, Fitchburg, MA 01420'
      },
      {
        id: '2',
        customerId: this.currentUser!.id,
        providerId: 2,
        serviceId: 's2',
        serviceName: 'House Cleaning Service',
        providerName: 'Sparkle Clean Services',
        scheduledDate: '2025-06-28',
        scheduledTime: '10:00',
        status: 'completed',
        price: 128.99,
        isRecurring: false,
        address: '123 Main St, Fitchburg, MA 01420'
      }
    ];
  }

  loadProjects(): void {
    this.projectService.getProjects().subscribe((projects) => {
      this.projects = projects.sort((a, b) => a.priority - b.priority);
      this.projects = this.projects.filter(project => (project.currentProjectPrice / project.totalProjectPrice) < 1);
    });
  }

  cancelBooking(bookingId: string): void {
    if (confirm('Are you sure you want to cancel this booking?')) {
      // Mock cancellation
      const booking = this.bookings.find(b => b.id === bookingId);
      if (booking) {
        booking.status = 'cancelled';
      }
    }
  }

  viewProjectDetails(projectId: string): void {
    this.router.navigate(['/projects/edit/', projectId]);
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  openReviewModal(bookingId: string): void {
    this.selectedBookingId = bookingId;
    this.reviewRating = 0;
    this.reviewComment = '';
    this.showReviewModal = true;
  }

  closeReviewModal(): void {
    this.showReviewModal = false;
    this.selectedBookingId = null;
    this.reviewRating = 0;
    this.reviewComment = '';
  }

  submitReview(): void {
    if (this.reviewRating === 0) {
      alert('Please select a rating');
      return;
    }
    
    // TODO: Call backend service to save review
    console.log('Review submitted:', {
      bookingId: this.selectedBookingId,
      rating: this.reviewRating,
      comment: this.reviewComment
    });
    
    alert('Thank you for your review!');
    this.closeReviewModal();
  }
}

